import * as React from 'react';
import { getAliasFromType, upperCaseFirst } from '../../../../utils/Utils';

export interface CreateEntityOptionProps {
  entityType: string;
  toggleCreateEntity: Function;
  icon: React.ReactNode;
  comingSoon?: boolean;
}

function CreateEntityOption(props: CreateEntityOptionProps) {
  const { entityType, toggleCreateEntity, icon, comingSoon = false } = props;

  const createEntityHandler = () => {
    if (comingSoon) {
      return;
    }
    toggleCreateEntity(entityType);
  };

  return (
    <li className="gigg-menu__item" onClick={createEntityHandler}>
      {icon}
      <span>
        Create {upperCaseFirst(entityType === 'competition' ? 'challenge' : getAliasFromType(entityType))}{' '}
        {comingSoon && <span>(Coming soon!)</span>}
      </span>
    </li>
  );
}

export default CreateEntityOption;
